import {
    IonAlert,
    IonBackButton,
    IonButton,
    IonButtons,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardSubtitle,
    IonCardTitle,
    IonContent,
    IonHeader,
    IonIcon,
    IonInput,
    IonItem,
    IonLabel,
    IonList,
    IonLoading,
    IonPage,
    IonTextarea,
    IonTitle,
    IonToast,
    IonToolbar,
    useIonViewDidEnter
} from '@ionic/react';
import { arrowBack, warningOutline } from 'ionicons/icons';
import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { MessageContext } from '../../../../../contexts/MessageContext';
import {
    fiscalInutilizarNumeracao,
    requestService
} from '../../../../../Utils/Services';
import './FiscalInutilizacao.css';

type Props = {
    abrirMenu: boolean;
};

const FiscalInutilizacao: React.FC<Props> = (props: Props) => {
    const history = useHistory();
    const { loja } = useContext(MessageContext);
    const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
    const { nomeMenu, setNomeMenu } = useContext(MessageContext);

    const [serie, setSerie] = useState("1");
    const [numeroInicial, setNumeroInicial] = useState("");
    const [numeroFinal, setNumeroFinal] = useState("");
    const [justificativa, setJustificativa] = useState("");
    const [ano, setAno] = useState(String(new Date().getFullYear()));
    const [certificadoSenha, setCertificadoSenha] = useState("");

    const [showLoading, setShowLoading] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [textToast, setTextToast] = useState("");
    const [toastColor, setToastColor] = useState("success");
    const [showConfirmAlert, setShowConfirmAlert] = useState(false);

    // Resultado
    const [resultadoInutilizacao, setResultadoInutilizacao] = useState<any>(null);

    useIonViewDidEnter(() => {
        setEsconderMenu(true);
        setNomeMenu("");
        setResultadoInutilizacao(null);
    });

    function validar(): boolean {
        if (!certificadoSenha) { mostrarToast("Informe a senha do certificado.", "warning"); return false; }
        if (!serie) { mostrarToast("Informe a série.", "warning"); return false; }
        if (!numeroInicial) { mostrarToast("Informe o número inicial.", "warning"); return false; }
        if (!numeroFinal) { mostrarToast("Informe o número final.", "warning"); return false; }
        if (parseInt(numeroInicial) > parseInt(numeroFinal)) {
            mostrarToast("Número inicial deve ser menor ou igual ao final.", "warning");
            return false;
        }
        if (justificativa.length < 15) {
            mostrarToast("A justificativa deve ter no mínimo 15 caracteres.", "warning");
            return false;
        }
        return true;
    }

    function confirmarInutilizacao() {
        if (!validar()) return;
        setShowConfirmAlert(true);
    }

    function inutilizar() {
        setShowLoading(true);

        requestService(
            fiscalInutilizarNumeracao.url,
            {
                method: fiscalInutilizarNumeracao.method,
                body: JSON.stringify({
                    empresaId: loja,
                    certificadoSenha: certificadoSenha,
                    serie: serie,
                    numeroInicial: Number(numeroInicial),
                    numeroFinal: Number(numeroFinal),
                    justificativa: justificativa,
                    ano: ano
                }),
                credentials: 'include',
                timeout: 30000
            },
            history,
            (response: any) => {
                setShowLoading(false);
                const dados = response.dados || response;
                setResultadoInutilizacao(dados);
                mostrarToast("Numeração inutilizada com sucesso!", "success");
            },
            (error: any) => {
                setShowLoading(false);
                mostrarToast(error.message || "Erro ao inutilizar numeração.", "danger");
            }
        );
    }

    function mostrarToast(msg: string, color: string) {
        setTextToast(msg);
        setToastColor(color);
        setShowToast(true);
    }

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar color="primary">
                    <IonButtons slot="start">
                        <IonBackButton icon={arrowBack} text='' />
                    </IonButtons>
                    <IonTitle slot="start">Inutilização de Numeração</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent className="fiscal-inutilizacao-container" color="light">

                <div className="fiscal-inutilizacao-info">
                    <p>
                        <IonIcon icon={warningOutline} style={{ verticalAlign: "middle", marginRight: "6px" }} />
                        A inutilização é obrigatória quando há salto de numeração nas notas fiscais. Esta ação é irreversível.
                    </p>
                </div>

                {resultadoInutilizacao ? (
                    <IonCard className="fiscal-inutilizacao-form">
                        <IonCardHeader>
                            <IonCardTitle style={{ fontSize: "18px", color: "#4caf50" }}>Inutilização realizada!</IonCardTitle>
                            <IonCardSubtitle>Protocolo: {resultadoInutilizacao.protocolo || "—"}</IonCardSubtitle>
                        </IonCardHeader>
                        <IonCardContent>
                            <p>Série: {serie}</p>
                            <p>Números: {numeroInicial} a {numeroFinal}</p>
                            <IonButton expand="block" style={{ marginTop: "16px" }} onClick={() => {
                                setResultadoInutilizacao(null);
                                setNumeroInicial("");
                                setNumeroFinal("");
                                setJustificativa("");
                            }}>
                                Nova inutilização
                            </IonButton>
                        </IonCardContent>
                    </IonCard>
                ) : (
                    <IonCard className="fiscal-inutilizacao-form">
                        <IonCardContent>
                            <IonList>
                                <IonItem>
                                    <IonLabel position="stacked">Senha do certificado *</IonLabel>
                                    <IonInput type="password" value={certificadoSenha} onIonChange={(e) => setCertificadoSenha(e.detail.value || "")} placeholder="Senha do certificado digital" />
                                </IonItem>
                                <IonItem>
                                    <IonLabel position="stacked">Ano *</IonLabel>
                                    <IonInput value={ano} onIonChange={(e) => setAno(e.detail.value || "")} type="number" maxlength={4} />
                                </IonItem>
                                <IonItem>
                                    <IonLabel position="stacked">Série *</IonLabel>
                                    <IonInput value={serie} onIonChange={(e) => setSerie(e.detail.value || "")} placeholder="Ex: 1" />
                                </IonItem>
                                <IonItem>
                                    <IonLabel position="stacked">Número Inicial *</IonLabel>
                                    <IonInput value={numeroInicial} onIonChange={(e) => setNumeroInicial(e.detail.value || "")} type="number" placeholder="Ex: 1" />
                                </IonItem>
                                <IonItem>
                                    <IonLabel position="stacked">Número Final *</IonLabel>
                                    <IonInput value={numeroFinal} onIonChange={(e) => setNumeroFinal(e.detail.value || "")} type="number" placeholder="Ex: 10" />
                                </IonItem>
                                <IonItem>
                                    <IonLabel position="stacked">Justificativa (mínimo 15 caracteres) *</IonLabel>
                                    <IonTextarea
                                        value={justificativa}
                                        onIonChange={(e) => setJustificativa(e.detail.value || "")}
                                        placeholder="Motivo da inutilização..."
                                        rows={3}
                                    />
                                </IonItem>
                            </IonList>

                            <div className={`fiscal-char-counter ${justificativa.length < 15 ? 'invalid' : ''}`}>
                                {justificativa.length}/15 caracteres mínimos
                            </div>

                            <IonButton expand="block" color="warning" onClick={confirmarInutilizacao} style={{ marginTop: "16px" }}>
                                Inutilizar numeração
                            </IonButton>
                        </IonCardContent>
                    </IonCard>
                )}

                <IonAlert
                    isOpen={showConfirmAlert}
                    onDidDismiss={() => setShowConfirmAlert(false)}
                    header="Confirmar inutilização"
                    message={`Deseja realmente inutilizar os números ${numeroInicial} a ${numeroFinal} da série ${serie}? Esta ação é irreversível.`}
                    buttons={[
                        { text: 'Cancelar', role: 'cancel' },
                        { text: 'Inutilizar', cssClass: 'primary', handler: () => inutilizar() }
                    ]}
                />

                <IonLoading isOpen={showLoading} message="Inutilizando numeração..." />

                <IonToast
                    isOpen={showToast}
                    position="top"
                    onDidDismiss={() => setShowToast(false)}
                    message={textToast}
                    duration={3000}
                    color={toastColor}
                />
            </IonContent>
        </IonPage>
    );
};

export default FiscalInutilizacao;
